export const BUTTON_STATE_TYPE_CODE = {
    cant_select: -1,
    need_select: 1,
    select_done: 2,
} as const;